export default "__VITE_ASSET__LmJPX6bf__"